import {AbstractTransform, TransformInteractionState} from "../abstract-transform";
import {SnapPoint} from "../../snap";
import {Feature, GeoJSON, Position} from "geojson";

export class EditorPointTransformTranslate extends AbstractTransform<TransformInteractionState> {
    public getVertexIcon(): string {
        return "map-move";
    }

    public getVertexSize():number{
      return 1;
    }

    display(state: TransformInteractionState, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void,): any {
        display(geojson);
    }

    async setCoordinates(state: TransformInteractionState, points: Position[]): Promise<void> {
        this.controller.interaction.historyPush(state);
        this.transformedFeature.setCoordinates(points[0] as any);
        this.vertexMarkers[0].geometry.coordinates = points[0];
        this.displayDrawFeature(this.vertexMarkers[0]);
        this.tick();
    }

    public transform(state: TransformInteractionState, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
        this.transformedFeature.setCoordinates(snapPoint.point as any);
        this.displayDrawFeature(this.transformedFeature);
    }
}
